import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useAccount} from "@mytour/platform";
import {MenuItem} from "app/pages/roles/menus/MenuItem";
import {Trans as Translate, useTranslation} from "react-i18next";
import {NavLink as Link} from "react-router";
import {Nav} from "reactstrap";
import {NavItem, NavLink} from "reactstrap";
import {NavDropdown} from "../../menus/NavDropdown";

export function AccountMenu({onClick}: {onClick: () => void}) {
  const {t: translate} = useTranslation();
  const {account} = useAccount();
  const login = account?.login;

  let loginDisplay = login;
  if (login && login.length > 10) {
    loginDisplay = `${login.substring(0, 8)}…`;
  }
  return (
    <>
      <Nav navbar>
        <NavItem>
          <NavLink
            tag={Link}
            to="/company-settings/my-business"
            id="config-menu"
            className="d-flex align-items-center"
            onClick={onClick}
          >
            <FontAwesomeIcon icon="wrench" />

            <span className="d-lg-block">{translate("global.menu.account.config")}</span>
          </NavLink>
        </NavItem>
      </Nav>

      <NavDropdown icon="user" name={loginDisplay} id="account-menu" data-cy="accountMenu">
        <MenuItem icon="circle-info" to="/account/support" onClick={onClick} data-cy="support">
          Support
        </MenuItem>
        <MenuItem icon="wrench" to="/account/settings" onClick={onClick} data-cy="settings">
          <Translate i18nKey="global.menu.account.settings">Settings</Translate>
        </MenuItem>
        <MenuItem icon="lock" to="/account/password" onClick={onClick} data-cy="passwordItem">
          <Translate i18nKey="global.menu.account.password">Password</Translate>
        </MenuItem>
        <MenuItem icon="sign-out-alt" to="/logout" onClick={onClick} data-cy="logout">
          <Translate i18nKey="global.menu.account.logout">Sign out</Translate>
        </MenuItem>
      </NavDropdown>
    </>
  );
}
